export default __webpack_public_path__ + "static/media/handshake.aa6a75d3.svg";